import { styled } from 'theme'

export const StyledRealEstateEditForm = styled.div`
  background-color: white;
  padding: 0rem 0rem 1rem;
  max-width: 700px;
  margin: 0 auto;
`

export const StyledTitle = styled.div`
  padding: 1rem;
  font-size: 18px;
  font-weight: bold;
`
